import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import BeerCounter from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BeerCounter />
  </React.StrictMode>
);
